export const defaultTokenAquisitionErrorCode = "UnexpectedError";
export const extraValidationRequiredErrorCode = "ExtraValidationRequired";

export class AuthenticationErrors {
  static PasswordLoginErrors = new Map([
    ["LoginFailed", "last-login-failed"],
    ["PasswordExpired", "last-login-password-expired"],
    ["AccountLocked", "last-login-failed-user-locked"],
    ["UserDeleted", "last-login-failed-user-deleted"],
    ["UnknownUser", "last-login-failed-user-unknown"],
    ["IncorrectLoginFormat", "last-login-failed-incorrect-login-format"],
    ["LocalPartMissing", "last-login-failed-incorrect-login-format"],
    ["DomainMissing", "last-login-failed-incorrect-login-format"],
    ["UnexpectedError", "unexpected-error"],
    ["ExtraValidationRequired", "extra-validation-required"],
  ]);

  static PictureOrQrLoginErrors = new Map([
    ["LoginFailed", "last-login-failed"],
    ["AccountLocked", "account-locked"],
    ["UnexpectedError", "unexpected-error"],
    ["UnknownUser", "expired"],
    ["UserDeleted", "user-deleted"],
    ["QrCodeExpired", "expired"]
  ]);

  static getErrorTranslationKey(code: string): string {
    return AuthenticationErrors.getErrorTranslationKeyInternal(AuthenticationErrors.PasswordLoginErrors, code);
  }

  static getErrorTranslationKeyForPictureOrQrLogin(code: string): string {
    return AuthenticationErrors.getErrorTranslationKeyInternal(AuthenticationErrors.PictureOrQrLoginErrors, code);
  }

  private static getErrorTranslationKeyInternal(map: Map<string, string>, code: string): string {
    let key = map.get(defaultTokenAquisitionErrorCode)!;
    if (map.has(code)) {
      key = map.get(code)!;
    }
    return key;
  }
}
